/**
 * Russian translation catalogue.
 *
 * Pattern: "English-as-key" — keys are the exact English source strings used
 * in t("...") calls across the app. Missing keys fall back to the key itself
 * (so adding/removing entries is non-breaking).
 *
 * Plural suffixes for i18next 19 (compatibilityJSON v3):
 *   _0 — one  (1, 21, 31, ...)        "1 минута"
 *   _1 — few  (2-4, 22-24, ...)       "3 минуты"
 *   _2 — many (0, 5-20, 25-30, ...)   "5 минут"
 *
 * Sections are alphabetised by source key; comments mark functional groupings.
 */
export default {
  // ── Plurals & legacy keys ─────────────────────────────────────────────
  "Credit": "Кредит",
  "Credit_0": "Кредит",
  "Credit_1": "Кредита",
  "Credit_2": "Кредитов",

  "NewMessage": "Новое сообщение",
  "NewMessage_0": "{{count}} новое сообщение",
  "NewMessage_1": "{{count}} новых сообщения",
  "NewMessage_2": "{{count}} новых сообщений",

  "minute": "{{count}} минут",
  "minute_0": "{{count}} минута",
  "minute_1": "{{count}} минуты",
  "minute_2": "{{count}} минут",

  "paypal": "PayPal",

  // ── A ──────────────────────────────────────────────────────────────────
  "About": "Описание",
  "About me": "Обо мне",
  "Add": "Добавить",
  "Add card": "Добавить карту",
  "Add description...": "Добавьте описание...",
  "Add to favorites": "В избранное",
  "Add to folder": "Добавить в папку",
  "All": "Все",
  "Already have an account?": "Уже есть аккаунт?",
  "Amount": "Сумма",
  "Appearance": "Внешний вид",
  "Appointments": "Встречи",
  "Archived chats": "Архив чатов",
  "Are you sure you want to delete this group?": "Точно удалить эту группу?",
  "Ask a question": "Задать вопрос",
  "Attachment": "Вложение",
  "Audio": "Аудио",
  "Auto-Record Video": "Авто-запись видео",
  "Availability": "Расписание",
  "Awesome": "Отлично",

  // ── B ──────────────────────────────────────────────────────────────────
  "Back": "Назад",
  "Background": "Фон",
  "Balance history": "История баланса",
  "Billing address": "Платёжный адрес",
  "Blur": "Размытие",
  "Book appointment": "Записаться на встречу",
  "Book now": "Записаться",
  "Booking confirmed": "Запись подтверждена",
  "By clicking Start you will start a new conference.": "По нажатию «Начать» вы запустите новую конференцию.",

  // ── C ──────────────────────────────────────────────────────────────────
  "CVV Code": "CVV-код",
  "Cached chats": "Кэшированные чаты",
  "Cached media": "Кэшированные медиа",
  "Cached messages": "Кэшированные сообщения",
  "Cached users": "Кэшированные пользователи",
  "Call active": "Идёт звонок",
  "Camera": "Камера",
  "Camera {{number}}": "Камера {{number}}",
  "Cancel": "Отмена",
  "Cancel selection": "Отменить выделение",
  "Cant create payment window": "Не удалось открыть окно оплаты",
  "Cant verify transaction": "Не удалось подтвердить транзакцию",
  "Change avatar": "Сменить аватар",
  "Change password": "Сменить пароль",
  "Channel": "Канал",
  "Channel (broadcast, only owner posts)": "Канал (вещание, пишет только владелец)",
  "Channel Info": "Информация о канале",
  "Channel name": "Название канала",
  "Chat": "Чат",
  "Choose": "Выбрать",
  "Choose which types of notifications you want to receive.": "Выберите, какие уведомления хотите получать.",
  "City": "Город",
  "Clear offline cache": "Очистить офлайн-кэш",
  "Click to edit": "Нажмите, чтобы редактировать",
  "Close": "Закрыть",
  "Coach video": "Видеопрезентация",
  "Code": "Код",
  "Conference call invite from {{screenName}}": "Приглашение в конференцию от {{screenName}}",
  "Conference not found": "Конференция не найдена",
  "Confirm": "Подтвердить",
  "Confirm account deletion": "Подтвердите удаление аккаунта",
  "Confirm email": "Подтвердите email",
  "Consultant": "Консультант",
  "Consultants": "Консультанты",
  "Contacts": "Контакты",
  "Continue": "Продолжить",
  "Copied!": "Скопировано!",
  "Copy Link": "Скопировать ссылку",
  "Copy link": "Скопировать ссылку",
  "Copy link and send it to people you want to chat with.":
    "Скопируйте ссылку и отправьте тем, с кем хотите пообщаться.",
  "Copy link and send it to people you want to invite to conference.":
    "Скопируйте ссылку и отправьте тем, кого хотите пригласить в конференцию.",
  "Copy link and share the Live chat with your friends.": "Скопируйте ссылку и поделитесь прямым эфиром с друзьями.",
  "Copy to clipboard": "Скопировать в буфер",
  "Correction": "Исправление",
  "County": "Округ",
  "Create": "Создать",
  "Create Channel": "Создать канал",
  "Create Group": "Создать группу",
  "Create account": "Создать аккаунт",
  "Create an account to get started": "Создайте аккаунт, чтобы начать",
  "Credit card number": "Номер карты",
  "Currency": "Валюта",
  "Customer": "Клиент",

  // ── D ──────────────────────────────────────────────────────────────────
  "Dark": "Тёмная",
  "Date": "Дата",
  "Default": "По умолчанию",
  "Delete": "Удалить",
  "Delete Channel": "Удалить канал",
  "Delete Chat": "Удалить чат",
  "Delete Group": "Удалить группу",
  "Delete account": "Удалить аккаунт",
  "Delete this chat and all messages permanently?": "Удалить этот чат и все сообщения навсегда?",
  "Delete this folder?": "Удалить эту папку?",
  "Delete {{count}} messages?": "Удалить {{count}} сообщений?",
  "Description": "Описание",
  "Details": "Подробности",
  "Do you want to end the appointment?": "Завершить встречу?",
  "Do you want to end the chat?": "Завершить чат?",
  "Do you want to end the live chat?": "Завершить прямой эфир?",
  "Document": "Документ",
  "Done": "Готово",
  "Don't have an account?": "Нет аккаунта?",
  "Draft": "Черновик",
  "Drop files here": "Перетащите файлы сюда",
  "Duration": "Длительность",

  // ── E ──────────────────────────────────────────────────────────────────
  "Email": "Email",
  "Email is required": "Укажите email",
  "Email verification": "Подтверждение email",
  "Emoji": "Эмодзи",
  "Enable Video Calls first": "Сначала включите видеозвонки",
  "Enable notifications": "Включить уведомления",
  "Enable push notifications to receive updates when you're away.":
    "Включите push-уведомления, чтобы получать обновления, пока вас нет.",
  "Enable video calls": "Включить видеозвонки",
  "Enable topics": "Включить темы",
  "{{actor}} added {{target}} to the group": "{{actor}} добавил(а) {{target}} в группу",
  "{{target}} was removed from the group": "{{target}} удалён(а) из группы",
  "{{actor}} left the group": "{{actor}} покинул(а) группу",
  "{{actor}} joined the group": "{{actor}} присоединился(лась) к группе",
  "A new member joined the group": "Новый участник присоединился к группе",
  "Will send when uploads finish": "Отправится после загрузки файлов",
  "Files are still uploading — the message was not sent.": "Файлы ещё загружаются — сообщение не отправлено.",
  "This file is too large to upload.": "Файл слишком большой для загрузки.",
  "No voice clone is set up yet — record a voice sample in Settings to translate voice messages.":
    "Голосовой клон ещё не настроен — запишите образец голоса в Настройках, чтобы переводить голосовые сообщения.",
  "Discard this recording?": "Отменить запись?",
  "Schedule message": "Отложенное сообщение",
  "Send later": "Отправить позже",
  "Pick a time in the future.": "Выберите время в будущем.",
  "Couldn't schedule the message. Please try again.": "Не удалось запланировать сообщение. Попробуйте ещё раз.",
  "Attachments can't be scheduled. Remove them or send now.": "Вложения нельзя отправить отложенно. Уберите их или отправьте сейчас.",
  "Some files failed to upload — the message was not sent.": "Часть файлов не загрузилась — сообщение не отправлено.",
  "Couldn't forward this message": "Не удалось переслать сообщение",
  "Failed to create the group. Please try again.": "Не удалось создать группу. Попробуйте ещё раз.",
  "Failed to create the channel. Please try again.": "Не удалось создать канал. Попробуйте ещё раз.",
  "End Now": "Завершить сейчас",
  "Enter your password": "Введите пароль",
  "Enter your password to confirm account deletion.": "Введите пароль, чтобы подтвердить удаление аккаунта.",
  "Estimated size": "Примерный размер",
  "Expiry": "Срок действия",

  // ── F ──────────────────────────────────────────────────────────────────
  "Failed to delete {{count}} message(s).": "Не удалось удалить {{count}} сообщ.",
  "Failed to join group": "Не удалось присоединиться к группе",
  "Favorites": "Избранное",
  "File": "Файл",
  "Files": "Файлы",
  "Filters": "Фильтры",
  "Find a Consultant": "Найти консультанта",
  "First Name": "Имя",
  "First name {{error}}": "Имя {{error}}",
  "Folder name": "Название папки",
  "Forgot Password": "Забыли пароль?",
  "Forgot password?": "Забыли пароль?",
  "Formatting": "Форматирование",
  "Forward": "Переслать",
  "Forward {{count}} messages": "Переслать {{count}} сообщений",
  "Forward message": "Переслать сообщение",

  // ── G ──────────────────────────────────────────────────────────────────
  "GIF API key not configured": "GIF API-ключ не настроен",
  "Get a new code in {{timer}} seconds": "Новый код через {{timer}} сек.",
  "Get instructions": "Получить инструкции",
  "Get your Calendly Token": "Получите ваш Calendly-токен",
  "Go live": "В эфир",
  "Go to Calendly": "Открыть Calendly",
  "Go to Messages": "Перейти в сообщения",
  "Group": "Группа",
  "Group Info": "О группе",
  "Group description": "Описание группы",
  "Group name": "Название группы",
  "Group not found": "Группа не найдена",
  "Guest": "Гость",

  // ── H ──────────────────────────────────────────────────────────────────
  "Have an account?": "Уже есть аккаунт?",
  "Hide Chat": "Скрыть чат",
  "Hide details": "Скрыть детали",
  "Hide this chat? You can find it in Archived chats.": "Скрыть этот чат? Найти его можно в архиве.",

  // ── I ──────────────────────────────────────────────────────────────────
  "ID": "ID",
  "If you’d like to reset your password, click the button below.": "Чтобы сбросить пароль, нажмите кнопку ниже.",
  "Image": "Изображение",
  "Incorrect password": "Неверный пароль",
  "Interface language": "Язык интерфейса",
  "Invite Link": "Ссылка-приглашение",
  "Invite": "Приглашение",

  // ── J ──────────────────────────────────────────────────────────────────
  "Join": "Войти",
  "Join call": "Присоединиться к звонку",
  "Join chat": "Войти в чат",
  "Join live chat": "Войти в эфир",
  "Joining group...": "Присоединение к группе...",
  "Just do it!": "Просто сделай это!",

  // ── L ──────────────────────────────────────────────────────────────────
  "Language": "Язык",
  "Last Name": "Фамилия",
  "Last name {{error}}": "Фамилия {{error}}",
  "Leave Group": "Покинуть группу",
  "Leave a review": "Оставить отзыв",
  "Leave this group?": "Покинуть эту группу?",
  "Less": "Меньше",
  "Light": "Светлая",
  "Links": "Ссылки",
  "Live chat invite from {{screenName}}": "Приглашение в эфир от {{screenName}}",
  "Live now": "В эфире",
  "Load more": "Загрузить ещё",
  "Loading...": "Загрузка...",
  "Log In": "Войти",
  "Log in": "Войти",
  "Log in or register to send a message": "Войдите или зарегистрируйтесь, чтобы отправить сообщение",
  "Log out": "Выйти",

  // ── M ──────────────────────────────────────────────────────────────────
  "Main info": "Основное",
  "Member": "Участник",
  "Member list": "Список участников",
  "Members": "Участники",
  "Message": "Сообщение",
  "Messages": "Сообщения",
  "Microphone": "Микрофон",
  "Microphone {{number}}": "Микрофон {{number}}",
  "More": "Ещё",
  "Muted": "Без звука",

  // ── N ──────────────────────────────────────────────────────────────────
  "Name": "Имя",
  "Name is required": "Укажите имя",
  "Name of card holder": "Имя владельца карты",
  "New Password": "Новый пароль",
  "New chat": "Новый чат",
  "New folder": "Новая папка",
  "New here?": "Впервые здесь?",
  "New messages": "Новые сообщения",
  "New message": "Новое сообщение",
  "Next": "Далее",
  "Next (Enter)": "Далее (Enter)",
  "Next step": "Следующий шаг",
  "No GIFs found": "GIF не найдены",
  "No archived chats": "В архиве пусто",
  "No chats found": "Чаты не найдены",
  "No chats in this folder": "В этой папке пусто",
  "No conversations yet": "Переписок пока нет",
  "No custom emoji": "Пользовательских эмодзи нет",
  "No emoji found": "Эмодзи не найдены",
  "No favourites yet — tap the star on any GIF to save it":
    "Пока пусто — нажмите звёздочку на любой GIF, чтобы сохранить",
  "No files": "Файлов нет",
  "No links": "Ссылок нет",
  "No matching result found": "Ничего не найдено",
  "No messages found": "Сообщения не найдены",
  "No messages here yet": "Сообщений пока нет",
  "No messages in this group yet": "В этой группе пока нет сообщений",
  "No one has read this yet": "Пока никто не прочитал",
  "No photo": "Без фото",
  "No photos": "Фото нет",
  "No public groups": "Публичных групп нет",
  "No recent GIFs yet": "Недавних GIF пока нет",
  "No replies yet": "Ответов пока нет",
  "No results": "Ничего не найдено",
  "No users found": "Пользователи не найдены",
  "No videos": "Видео нет",
  "No voice messages": "Голосовых сообщений нет",
  "None": "Нет",
  "Not a registered user?": "Ещё не зарегистрированы?",
  "Not now": "Не сейчас",
  "Nothing found": "Ничего не найдено",
  "Notifications": "Уведомления",
  "Now you can log in without any problems": "Теперь вы можете спокойно войти",

  // ── O ──────────────────────────────────────────────────────────────────
  "Offline": "Не в сети",
  "Once you delete your account, all your data will be permanently removed.":
    "После удаления аккаунта все ваши данные будут безвозвратно удалены.",
  "Online": "В сети",
  "Only the channel owner can post here": "Сообщения здесь публикует только владелец канала",
  "Other payment in process": "Идёт другая оплата",
  "Owner": "Владелец",
  "Owner only": "Только владелец",

  // ── P ──────────────────────────────────────────────────────────────────
  "Paid": "Оплачено",
  "Password": "Пароль",
  "Password changed successfully": "Пароль успешно изменён",
  "Password is required": "Укажите пароль",
  "Past": "Прошедшие",
  "Pay for an appointment": "Оплатить встречу",
  "Pay now": "Оплатить",
  "Pay service": "Оплатить услугу",
  "PayPal email address": "Email PayPal",
  "Payee information": "Данные получателя",
  "Payment": "Платёж",
  "Payment canceled": "Платёж отменён",
  "Payout": "Выплата",
  "Payout system": "Платёжная система",
  "Personal Information": "Личная информация",
  "Phone Number": "Номер телефона",
  "Photo ID": "Удостоверение с фото",
  "Photo scan of ID": "Скан удостоверения",
  "Photo with ID": "Фото с удостоверением",
  "Photos": "Фото",
  "Pinned message": "Закреплённое сообщение",
  "Pinned messages": "Закреплённые сообщения",
  "Please select a rating": "Выберите оценку",
  "Posting": "Публикация",
  "Powered by SMeet ": "Работает на SMeet ",
  "Practice area": "Сфера практики",
  "Practice area tags": "Теги сферы практики",
  "Previous (Shift+Enter)": "Назад (Shift+Enter)",
  "Previous Step": "Назад",
  "Pricing": "Цены",
  "Privacy Policy": "Политика конфиденциальности",
  "Private chat": "Личный чат",
  "Profile": "Профиль",
  "Public Group": "Публичная группа",
  "Public Groups": "Публичные группы",
  "Public broadcast": "Публичное вещание",
  "Public group": "Публичная группа",
  "Publish": "Опубликовать",
  "Push notifications": "Push-уведомления",
  "Push notifications are blocked. Please enable them in your browser settings.":
    "Push-уведомления заблокированы. Включите их в настройках браузера.",
  "Push notifications are not supported in this browser.": "Push-уведомления не поддерживаются в этом браузере.",

  // ── R ──────────────────────────────────────────────────────────────────
  "Read by": "Прочитали",
  "Refill Account": "Пополнить счёт",
  "Refill account": "Пополнить счёт",
  "Refill balance": "Пополнить баланс",
  "Refund": "Возврат",
  "Remove": "Удалить",
  "Remove avatar": "Удалить аватар",
  "Remove from favorites": "Убрать из избранного",
  "Rename": "Переименовать",
  "Replace video": "Заменить видео",
  "Reply in thread...": "Ответ в ветке...",
  "Resend verification code": "Отправить код ещё раз",
  "Restore": "Восстановить",
  "Review is published": "Отзыв опубликован",
  "Reviews": "Отзывы",
  "Round Video": "Круглое видео",

  // ── S ──────────────────────────────────────────────────────────────────
  "Save": "Сохранить",
  "Save Changes": "Сохранить изменения",
  "Save card": "Сохранить карту",
  "Saved Messages": "Сохранённые сообщения",
  "Schedule": "Расписание",
  "Scheduled messages": "Отложенные сообщения",
  "Search": "Поиск",
  "Search GIFs...": "Поиск GIF...",
  "Search across all your meetings and chats": "Поиск по всем встречам и чатам",
  "Search by name": "Поиск по имени",
  "Search by the name": "Поиск по имени",
  "Search chats...": "Поиск по чатам...",
  "Share to chat": "Поделиться в чат",
  "Search emoji...": "Поиск эмодзи...",
  "Search group...": "Поиск групп...",
  "Search in chat names": "Поиск в названиях чатов",
  "Search in messages": "Поиск в сообщениях",
  "Search messages": "Поиск сообщений",
  "Search messages...": "Поиск сообщений...",
  "Search practice area": "Поиск сферы практики",
  "Search users to add...": "Поиск пользователей для добавления...",
  "Search users...": "Поиск пользователей...",
  "Searching...": "Поиск...",
  "See details": "Подробнее",
  "Select a chat to start messaging": "Выберите чат, чтобы начать общение",
  "Select a rating": "Выберите оценку",
  "Selected messages": "Выбранные сообщения",
  "Send": "Отправить",
  "Send at": "Отправить в",
  "Send via email": "Отправить на email",
  "Sending video message...": "Отправка видеосообщения...",
  "Sending voice message...": "Отправка голосового...",
  "Services": "Услуги",
  "Set Password": "Установить пароль",
  "Set up your availability": "Настройте расписание",
  "Settings": "Настройки",
  "Share": "Поделиться",
  "Share link": "Поделиться ссылкой",
  "Share your new Live Chat": "Поделитесь новым эфиром",
  "Shared Media": "Общие медиа",
  "Shared media": "Общие медиа",
  "Sign Up": "Регистрация",
  "Sign in to your account to continue": "Войдите в аккаунт, чтобы продолжить",
  "Sign up in Calendly": "Зарегистрироваться в Calendly",
  "Something went wrong. Please try again.": "Что-то пошло не так. Попробуйте ещё раз.",
  "Something wrong": "Что-то пошло не так",
  "Start": "Начать",
  "Start call": "Начать звонок",
  "Start consulting": "Начать консультацию",
  "Start now": "Начать сейчас",
  "Start stream": "Начать эфир",
  "Start typing tags. Hit tab, comma, or return to complete. Hit backspace/delete to remove.":
    "Начните вводить теги. Tab, запятая или Enter — завершить. Backspace/Delete — удалить.",
  "State": "Регион",
  "Status": "Статус",
  "Storage": "Хранилище",
  "Street address": "Адрес",
  "Submit": "Отправить",
  "Subscribers": "Подписчики",
  "Success": "Успех",
  "Successfully joined! Redirecting...": "Успешно! Переходим...",
  "Support": "Поддержка",

  // ── T ──────────────────────────────────────────────────────────────────
  "Terms of Use": "Условия использования",
  "The appointment cannot be resumed after completion.": "После завершения встречу нельзя возобновить.",
  "The appointment is over": "Встреча завершена",
  "The appointment with {{screenName}} has already started": "Встреча с {{screenName}} уже началась",
  "The file size may not be over {{size}}": "Размер файла не должен превышать {{size}}",
  "The money was transferred successfully": "Перевод выполнен",
  "Theme": "Тема",
  "There are no reviews yet": "Отзывов пока нет",
  "This action cannot be undone.": "Это действие нельзя отменить.",
  "This conference has ended": "Конференция завершена",
  "This conference is not available for guest access": "Эта конференция недоступна для гостей",
  "This field cannot be empty": "Поле не может быть пустым",
  "This group is not public": "Эта группа не публичная",
  "This page is undergoing maintenance. Please bear with us, we'll be back shortly!":
    "На странице ведутся работы. Скоро всё вернётся!",
  "Thread": "Ветка",
  "Time / Duration": "Время / длительность",
  "Title": "Заголовок",
  "Today": "Сегодня",
  "Toggle favourite": "В избранное",
  "Transcribing voice...": "Расшифровка голоса...",
  "Try again": "Попробовать снова",
  "Type": "Тип",

  // ── U ──────────────────────────────────────────────────────────────────
  "Unpaid": "Не оплачено",
  "Unpin": "Открепить",
  "Unsubscribe": "Отписаться",
  "Upcoming": "Предстоящие",
  "Upload": "Загрузить",
  "Upload photo": "Загрузить фото",
  "Upload video": "Загрузить видео",
  "Upload your presentation video to promote your services more effectively.":
    "Загрузите презентационное видео, чтобы эффективнее продвигать услуги.",
  "Uploading error": "Ошибка загрузки",
  "User": "Пользователь",

  // ── V ──────────────────────────────────────────────────────────────────
  "Verifying access...": "Проверяем доступ...",
  "Video": "Видео",
  "Video Calls": "Видеозвонки",
  "Video call": "Видеозвонок",
  "Videos": "Видео",
  "Voice": "Голосовые",
  "Voice & Video settings": "Настройки голоса и видео",
  "Voice call": "Голосовой звонок",
  "Voice message": "Голосовое сообщение",
  "Video message": "Видеосообщение",

  // ── W ──────────────────────────────────────────────────────────────────
  "Waiting for network...": "Ожидание сети...",
  "Waiting for participants": "Ожидание участников",
  "We sent you a 6-digit code": "Мы отправили 6-значный код",
  "We will send an email with instructions.": "Мы отправим письмо с инструкциями.",
  " We will send an email with instructions.": "Мы отправим письмо с инструкциями.",
  "Website": "Сайт",
  "Write a review": "Написать отзыв",
  "Write your review": "Напишите отзыв",

  // ── Y ──────────────────────────────────────────────────────────────────
  "Yesterday": "Вчера",
  "You agree to our Terms of Service": "Вы соглашаетесь с условиями использования",
  "You are muted": "Ваш микрофон выключен",
  "You currently have no events": "У вас пока нет событий",
  "You have booked an appointment with {{screenName}}": "Вы записались на встречу с {{screenName}}",
  "You have to accept the Terms and Conditions": "Нужно принять условия",
  "You may set up dates available for booking after the account is verified":
    "Доступные для записи даты можно настроить после верификации аккаунта",
  "You must agree to our Terms of Service": "Вы должны принять условия использования",
  "Your Email": "Ваш email",
  "Your Personal Access Token": "Ваш персональный токен доступа",
  "Your account has been refilled": "Ваш счёт пополнен",
  "Your name": "Ваше имя",

  // ── Z ──────────────────────────────────────────────────────────────────
  "Zip code": "Индекс",

  // ── Lowercase / inline pieces ─────────────────────────────────────────
  "contact support team": "связаться с поддержкой",
  "guests {{count}}": "гостей: {{count}}",
  "members": "участников",
  "min": "мин.",
  "of {{maxLength}}": "из {{maxLength}}",
  "or Log In with": "или войти через",
  "or Sign Up with": "или регистрация через",
  "replies": "ответов",
  "reply": "ответ",
  "subscribers": "подписчиков",
  "typing...": "печатает...",

  // ── Interpolated phrases ──────────────────────────────────────────────
  "{{count}} people typing...": "{{count}} печатают...",
  "{{count}} selected": "Выбрано: {{count}}",
  "{{name}} is typing...": "{{name}} печатает...",
  "{{screenName}} has invited you to join a conference call. {{chatLink}}":
    "{{screenName}} приглашает вас в видеоконференцию. {{chatLink}}",
  "{{screenName}} has invited you to join a live chat. {{chatLink}}":
    "{{screenName}} приглашает вас в прямой эфир. {{chatLink}}",
  "{{totalRecords}} results": "Результатов: {{totalRecords}}",
  "Сlick here if your Calendly Schedule is different from this one":
    "Нажмите здесь, если ваше расписание Calendly отличается от этого",

  // ── Review pass — translation review additions (messages, calls, AI) ──
  "AI meeting insights": "ИИ-аналитика встречи",
  "AI meeting summary": "ИИ-саммари встречи",
  "AI summary in progress…": "ИИ-саммари готовится…",
  "AI summary loading…": "Загрузка ИИ-саммари…",
  "Action items": "Задачи",
  "Active ({{language}}, {{duration}})": "Активно ({{language}}, {{duration}})",
  "Ask anything about your meetings…": "Спросите что угодно про ваши встречи…",
  "Ask": "Спросить",
  "Back to messages": "Назад к сообщениям",
  "Consent at": "Согласие от",
  "Copy citation": "Скопировать цитату",
  "Copy": "Копировать",
  "Couldn’t load summary": "Не удалось загрузить саммари",
  "Create channel": "Создать канал",
  "Create group": "Создать группу",
  "Custom": "Свои",
  "Decisions": "Решения",
  "Decline": "Отклонить",
  "Delete profile": "Удалить профиль",
  "Enrolled": "Готово",
  "End call": "Завершить звонок",
  "Failed to load file": "Не удалось загрузить файл",
  "Failed to send": "Не удалось отправить",
  "Failed": "Ошибка",
  "Find phrases, decisions, names…": "Найти фразы, решения, имена…",
  "Forwarded from {{name}}": "Переслано от {{name}}",
  "Fullscreen": "На весь экран",
  "GIF": "GIF",
  "Go to mention": "К упоминанию",
  "Hide transcription": "Скрыть расшифровку",
  "I confirm this is my own voice and I consent to its use for translating my voice messages on this server. I can delete the profile at any time.":
    "Подтверждаю, что это мой голос, и согласен на его использование для перевода моих голосовых сообщений на этом сервере. Я могу удалить профиль в любой момент.",
  "Incoming call...": "Входящий звонок…",
  "Insights": "Инсайты",
  "Loading status…": "Загрузка статуса…",
  "Loading…": "Загрузка…",
  "Meeting Memory": "Память встреч",
  "Memory is disabled on this server.": "Память встреч отключена на этом сервере.",
  "Set MEMORY_ENABLED=true after provisioning the embedding service and AI database.":
    "Установите MEMORY_ENABLED=true после развёртывания сервиса эмбеддингов и ИИ-базы.",
  "Mute": "Выключить микрофон",
  "No speech detected.": "Речь не обнаружена.",
  "Open Meeting Memory": "Открыть память встреч",
  "Open chat ↗": "Открыть чат ↗",
  "Pin": "Закрепить",
  "Pinned": "Закреплено",
  "Playback speed: {{rate}}x": "Скорость воспроизведения: {{rate}}x",
  "Queued…": "В очереди…",
  "Re-enroll": "Перерегистрировать",
  "Re-record": "Перезаписать",
  "Re-run analysis": "Перезапустить анализ",
  "Read these two sentences out loud (~7-10 seconds total)": "Прочитайте вслух эти две фразы (примерно 7–10 секунд)",
  "Record a short reference clip so the messenger can translate your voice messages into other languages while keeping your voice. Your audio stays on your team's servers — never sent to an external service.":
    "Запишите короткий образец голоса, чтобы мессенджер мог переводить ваши голосовые сообщения на другие языки, сохраняя ваш голос. Аудио остаётся на серверах вашей команды — никогда не уходит к стороннему сервису.",
  "Recording {{elapsed}}s / {{max}}s": "Запись {{elapsed}}с / {{max}}с",
  "Recording": "Запись",
  "Reply in thread": "Ответить в ветке",
  "Reply": "Ответить",
  "Retranscribe": "Перерасшифровать",
  "Retrying…": "Повтор…",
  "Save voice profile": "Сохранить голосовой профиль",
  "Script language": "Язык скрипта",
  "Select": "Выбрать",
  "Send as text (on)": "Отправить текстом (включено)",
  "Send as text": "Отправить текстом",
  "Sending...": "Отправка…",
  "Sent an attachment": "Отправил(а) вложение",
  "Show transcription": "Показать расшифровку",
  "Sources": "Источники",
  "Speaking time": "Время речи",
  "Start recording": "Начать запись",
  "Stop": "Стоп",
  "Stop recording": "Остановить запись",
  "Summary failed": "Саммари не построено",
  "The AI is reading the transcript and extracting decisions and action items.":
    "ИИ читает расшифровку и извлекает решения и action items.",
  "This message was deleted": "Сообщение удалено",
  "This recording has no per-participant audio tracks and cannot be transcribed.":
    "В этой записи нет отдельных дорожек участников — расшифровать нельзя.",
  'Tip: ask "What did we decide about pricing?" or "When did we discuss the launch?".':
    "Подсказка: спросите «Что мы решили по ценообразованию?» или «Когда мы обсуждали запуск?».",
  "Top matches": "Лучшие совпадения",
  "Topics": "Темы",
  "Transcribe": "Расшифровать",
  "Transcribing…": "Расшифровка…",
  "Transcript": "Расшифровка",
  "Translate to my language (in the speaker's voice)": "Перевести на мой язык (голосом говорящего)",
  "Translation failed": "Не удалось перевести",
  "Turn off camera": "Выключить камеру",
  "Turn on camera": "Включить камеру",
  "Unknown": "Неизвестно",
  "Unmute": "Включить микрофон",
  "Uploading and processing…": "Загрузка и обработка…",
  "Uploading recording...": "Загрузка записи…",
  "User not found": "Пользователь не найден",
  "User profile": "Профиль пользователя",
  "User {{id}}": "Пользователь {{id}}",
  "Voice Clone": "Голосовой клон",
  "Voice only": "Только голос",
  "chat": "чат",
  "edited": "ред.",
  "recording": "запись",
  "scope: this chat": "только этот чат",
  "thread {{id}}": "ветка {{id}}",
  "{{count}} segments": "{{count}} сегментов",
  "{{seconds}}s recorded": "записано {{seconds}}с",
  "✓ Copied": "✓ Скопировано",
  "✓ Voice profile saved. Open any of your voice messages in chat to test the translation toggle.":
    "✓ Голосовой профиль сохранён. Откройте любое из ваших голосовых сообщений в чате, чтобы протестировать перевод.",

  // ── Review pass 3 — push-categories, refill labels, recording link ────
  // Push-notification categories from PageNotificationSettings/CATEGORY_LABELS
  // ("Messages" / "Reviews" already exist above, kept here for context).
  "Calls": "Звонки",
  "Live streams": "Прямые эфиры",
  "Posts": "Посты",
  // ModalBalanceRefill — refillButtonText is a dynamic string, so the
  // English source needs explicit catalogue entries.
  "Refill": "Пополнить",
  "Refill now": "Пополнить сейчас",
  "Download recording": "Скачать запись",

  // Call system-message labels (rendered client-side from JSON payload)
  "Delete this message?": "Удалить это сообщение?",
  "Failed to delete the message. Please try again.": "Не удалось удалить сообщение. Попробуйте ещё раз.",
  "Voice message unavailable": "Голосовое сообщение недоступно",
  "Microphone requires HTTPS or localhost. Current page is not secure.":
    "Микрофон требует HTTPS или localhost. Текущая страница не защищена.",
  "No speech detected — nothing to send.": "Речь не распознана — отправлять нечего.",
  "Couldn't transcribe — sent as a voice message instead.":
    "Не удалось расшифровать — отправлено как голосовое сообщение.",
  "Couldn't send your voice message. Please try again.":
    "Не удалось отправить голосовое сообщение. Попробуйте ещё раз.",
  "Call ended": "Звонок завершён",
  "Call ended ({{duration}})": "Звонок завершён ({{duration}})",
  "Call ({{duration}})": "Звонок ({{duration}})",
  "Group ({{count}})": "Группа ({{count}})",
  "Cancelled call": "Звонок отменён",
  "Missed call": "Пропущенный звонок",
  "Call declined": "Звонок отклонён",
  "Declined call": "Отклонённый звонок",
  "Call": "Звонок",
  "Open insights": "Открыть аналитику",

  // ── Review pass 4 — Features-page SVG infographics ────────────────────
  // InfographicMessaging
  "The quarterly review is scheduled": "Запланирован квартальный обзор",
  "Perfect, I'll prepare the slides": "Отлично, подготовлю слайды",
  "Updated: meeting moved to 3 PM": "Обновлено: встреча в 15:00",
  "@You": "@Вы",
  "can you share the deck?": "поделишься презентацией?",
  "Here's the latest version": "Вот свежая версия",
  "PIN + HIDE": "ПИН + СКРЫТЬ",
  "SEARCH": "ПОИСК",
  "@MENTIONS": "@УПОМИНАНИЯ",
  "EMOJI": "ЭМОДЗИ",

  // InfographicVideo
  "Speaking...": "Говорит...",
  "Screen Share": "Демонстрация экрана",
  "4 participants": "4 участника",
  "End": "Завершить",

  // InfographicGroups
  "GROUP NAME": "НАЗВАНИЕ ГРУППЫ",
  "Design Team": "Дизайн-команда",
  "MEMBERS": "УЧАСТНИКИ",
  "Search groups...": "Поиск групп...",
  "{{count}} members": "{{count}} участников",
  "Engineering": "Инжиниринг",
  "Marketing": "Маркетинг",
  "All Hands": "Общий созвон",
  "Joined": "Вступил",

  // InfographicFiles
  "Supported File Types": "Поддерживаемые типы файлов",
  "Images": "Изображения",
  "{{count}} formats": "Форматов: {{count}}",
  "+ inline preview": "+ инлайн-превью",
  "+ range seeking": "+ перемотка по диапазону",
  "Docs": "Документы",
  "Drag & Drop": "Перетащите",
  "Drop files anywhere in the chat": "Бросьте файлы в любое место чата",
  "Secure cloud, up to 2 GB": "Защищённое облако, до 2 ГБ",
  "Preview": "Просмотр",
  "Inline thumbnails + lightbox": "Инлайн-превью + лайтбокс",
  "Download link": "Ссылка на скачивание",

  // InfographicSecurity
  "Token Login": "Вход по токену",
  "Stays signed in": "Сессия не сбрасывается",
  "QR Login": "Вход по QR",
  "5-min TTL session": "Сессия 5 минут",
  "Social Login": "Вход через соцсети",
  "Roles": "Роли",
  "Owner · Admin · Member": "Владелец · Админ · Участник",
  "QR Authentication Flow": "Поток QR-аутентификации",
  "Generate QR": "Сгенерировать QR",
  "Scan on phone": "Скан с телефона",
  "Poll status": "Опрос статуса",
  "Logged in!": "Вход выполнен!",

  // InfographicRealtime
  "Real-Time": "Real-Time",
  "Hub": "Хаб",
  "Real-time delivery": "Доставка в реальном времени",
  "Instant @ alerts": "Мгновенные @ уведомления",
  "Online Status": "Онлайн-статус",
  "Presence tracking": "Отслеживание присутствия",
  "Live emoji updates": "Живые эмодзи-обновления",
  "Incoming ring": "Входящий звонок",
  "Push": "Push",
  "Message delivery": "Доставка сообщений",
  "History load (50 msgs)": "Загрузка истории (50 сообщ.)",
  "Max file size": "Макс. размер файла",
  "Members per group": "Участников в группе",

  // InfographicChannels
  "Product News": "Новости продукта",
  "{{count}} subscribers": "{{count}} подписчиков",
  "Team Chat": "Командный чат",
  "Admin": "Админ",
  "We just launched v2.5 with Channels!": "Мы запустили v2.5 с каналами!",
  "Key highlights of the release:": "Ключевые особенности релиза:",
  "- Broadcast channels for announcements": "- Каналы-вещания для анонсов",
  "subscribers reading": "подписчиков читают",

  // InfographicLinkPreview
  "How to Build Modern Chat Apps": "Как делать современные чат-приложения",
  "A comprehensive guide to real-time messaging...": "Подробный гид по real-time сообщениям...",
  "1. User sends URL": "1. Пользователь шлёт URL",
  "in message text": "в тексте сообщения",
  "2. Preview pulled": "2. Превью получено",
  "title, image, description": "заголовок, картинка, описание",
  "3. Cached for speed": "3. Закэшировано",
  "Same link loads instantly": "Та же ссылка грузится мгновенно",
  "4. Preview rendered": "4. Превью отрисовано",
  "title, desc, image, domain": "заголовок, описание, картинка, домен",
  "Safe by default": "Безопасно по умолчанию",
  "Blocks internal addresses": "Блокирует внутренние адреса",
  "Strict size + redirect limits": "Жёсткие лимиты по размеру и редиректам",

  // InfographicMarkdown
  "RAW INPUT": "ИСХОДНЫЙ ТЕКСТ",
  "RENDERED": "РЕНДЕР",
  "bold text": "жирный текст",
  "italic text": "курсивный текст",
  "strikethrough": "зачёркнутый",
  "blockquote text": "текст цитаты",
  "mention user": "упоминание пользователя",
  "7 formatting styles supported": "Поддерживается 7 стилей форматирования",
  "Works alongside @mentions and search highlights": "Работает вместе с @упоминаниями и подсветкой поиска",

  // InfographicCommunication
  "VOICE MESSAGE": "ГОЛОСОВОЕ",
  "Can we ship by Friday?": "Успеем к пятнице?",
  "Yes, already pushed the fix!": "Да, уже выкатил фикс!",
  "REPLY": "ОТВЕТ",
  "Forwarded from Bob": "Переслано от Bob",
  "Check out this article!": "Посмотри эту статью!",
  "FORWARD": "ПЕРЕСЫЛКА",
  "Alice is typing": "Alice печатает",
  "TYPING": "НАБОР",
  "PIN": "ЗАКРЕП",
  "Meeting agenda: Review Q2 roadmap and assign tasks": "Повестка: разбор Q2-роадмапа и распределение задач",
  "DELETE": "УДАЛЕНИЕ",
  "Everything in one bubble": "Всё в одном пузыре",
  "Reply, forward, voice, pin & delete — all in one place":
    "Ответ, пересылка, голос, закрепление и удаление — в одном месте",
  "Same smooth experience across every device": "Один и тот же плавный опыт на любых устройствах",

  // InfographicAdvancedCalls
  "You": "Вы",
  "Good": "Отлично",
  "Incoming Call": "Входящий звонок",
  "Reconnecting... attempt 2/5 (2s)": "Переподключение... попытка 2/5 (2с)",

  // InfographicSmartRecording
  "COMPOSITED RECORDING": "СОБРАННАЯ ЗАПИСЬ",
  "Compatible:": "Совместимо:",
  "STORAGE & METADATA": "ХРАНИЛИЩЕ И МЕТАДАННЫЕ",
  "1. Client records & uploads": "1. Клиент пишет и загружает",
  "HD video + audio, up to 2 GB": "HD-видео + аудио, до 2 ГБ",
  "2. Server stores securely": "2. Сервер хранит безопасно",
  "Encrypted, range-seekable": "Зашифровано, с перемоткой",
  "3. Metadata saved": "3. Метаданные сохранены",
  "conferenceId, participants, duration": "ID конференции, участники, длительность",
  "4. Inline chat preview": "4. Инлайн-превью в чате",
  "Download": "Скачать",
  "Download failed": "Не удалось скачать",
  "Zoom in": "Увеличить",
  "Zoom out": "Уменьшить",
  "Reset zoom": "Сбросить масштаб",
  "Auto-cleanup: 7 day retention": "Авто-очистка: хранение 7 дней",
  "MESSAGE THREADS": "ВЕТКИ СООБЩЕНИЙ",
  "Ship today?": "Выкатываем сегодня?",
  "Yes, PR merged": "Да, PR влит",
  "LGTM, deploying": "LGTM, деплою",
  "Reply...": "Ответ...",

  // InfographicChatFolders
  "Search...": "Поиск...",
  "FOLDER TABS": "ВКЛАДКИ ПАПОК",
  "Work": "Работа",
  "Friends": "Друзья",
  "RIGHT-CLICK MENU": "МЕНЮ ПРАВОГО КЛИКА",
  "Personal": "Личное",
  "Projects": "Проекты",
  "CROSS-DEVICE SYNC": "СИНХРОНИЗАЦИЯ МЕЖДУ УСТРОЙСТВАМИ",
  "Your folders follow you everywhere": "Папки следуют за вами везде",

  // InfographicNativeCalls
  "CALLER": "ЗВОНЯЩИЙ",
  "Calling...": "Вызов...",
  "Server": "Сервер",
  "Incoming call": "Входящий звонок",
  "Push to iPhone": "Push на iPhone",
  "Apple-certified": "Apple-сертифицированный",
  "Voice-call push": "Push для голосового звонка",
  "Reserved channel": "Зарезервированный канал",
  "Rings within seconds": "Звонит за секунды",
  "CALLEE (LOCKED)": "ПОЛУЧАТЕЛЬ (БЛОКИРОВКА)",
  "incoming call": "входящий звонок",
  "Accept": "Принять",
  "Works even when app is KILLED": "Работает даже когда приложение ЗАКРЫТО",

  // InfographicConferenceTranscription
  "PER-SPEAKER AUDIO": "АУДИО ПО ДИКТОРАМ",
  "AI Transcribe": "ИИ-расшифровка",
  "99 languages": "99 языков",
  "privately hosted": "self-hosted",
  "TRANSCRIPT": "РАСШИФРОВКА",
  "PIPELINE": "ПАЙПЛАЙН",
  "Auto on stop": "Авто после стопа",
  "queue → segments → store": "очередь → сегменты → хранилище",
  "Pollable status": "Опрос статуса",
  "pending → running → done": "ожидает → идёт → готово",
  "Export .txt / .srt": "Экспорт .txt / .srt",
  "timestamped, downloadable": "с таймкодами, скачиваемо",
  "Privacy by design": "Приватность по умолчанию",
  "Audio never leaves your servers — no external API calls, no quotas, no per-minute pricing.":
    "Аудио не покидает ваши серверы — никаких внешних API, квот и поминутной оплаты.",

  // InfographicVoiceClone
  "1 · ENROLL ONCE (30s)": "1 · ЗАПИСАТЬ ОДИН РАЗ (30с)",
  "Read 5 sentences": "Прочитайте 5 фраз",
  "“Hi, my name is here, and I work…”": "«Привет, меня зовут так-то, я работаю…»",
  "“Today the weather is calm…”": "«Сегодня погода спокойная…»",
  "“We discussed important questions…”": "«Мы обсудили важные вопросы…»",
  "Recording 21.3s / 60s": "Запись 21.3с / 60с",
  "Voice Clone AI": "ИИ-клонирование голоса",
  "no third-party calls": "без сторонних вызовов",
  "Voice profile": "Голосовой профиль",
  "on-prem only": "только on-prem",
  "2 · TRANSLATE EVERY VOICE MESSAGE — IN YOUR VOICE": "2 · ПЕРЕВЕДИТЕ ЛЮБОЕ ГОЛОСОВОЕ — ВАШИМ ГОЛОСОМ",
  "LANG TOGGLE": "ВЫБОР ЯЗЫКА",
  "Original": "Оригинал",
  "Anton (EN) · in his own voice": "Anton (EN) · его же голосом",
  "Consent + delete": "Согласие + удаление",
  "GDPR-friendly": "GDPR-совместимо",

  // InfographicMeetingCoach
  "AI MEETING SUMMARY": "ИИ-САММАРИ ВСТРЕЧИ",
  "45m · 5 ppl": "45 мин · 5 чел",
  "SUMMARY": "САММАРИ",
  "Q3 budget approved at -15%. Stripe integration assigned to Maria.":
    "Бюджет Q3 одобрен с -15%. Интеграция Stripe назначена Maria.",
  "TOPICS": "ТЕМЫ",
  "budget": "бюджет",
  "release": "релиз",
  "hiring": "найм",
  "DECISIONS": "РЕШЕНИЯ",
  "Release 2.5 → Friday": "Релиз 2.5 → пятница",
  "Cut marketing budget by 15%": "Сократить маркетинг-бюджет на 15%",
  "ACTION ITEMS": "ЗАДАЧИ",
  "Release plan by 05-02": "План релиза до 02.05",
  "Stripe MVP by 05-08": "Stripe MVP до 08.05",
  "SPEAKING TIME": "ВРЕМЯ РЕЧИ",

  // InfographicMeetingMemory
  "When did we discuss the Q3 budget?": "Когда мы обсуждали бюджет Q3?",
  "ANSWER": "ОТВЕТ",
  "On April 22 you decided to cut Q3 marketing by 15%": "22 апреля вы решили урезать маркетинг Q3 на 15%",
  "and reallocate to Stripe integration": "и перенаправить на интеграцию Stripe",
  "SOURCES": "ИСТОЧНИКИ",
  "RECORDING": "ЗАПИСЬ",
  "“Q3 budget — let’s tighten 15%, marketing first…”": "«Бюджет Q3 — режем 15%, начнём с маркетинга…»",
  "Open at 14:32": "Открыть на 14:32",
  "CHAT": "ЧАТ",
  "“Q3 budget approved — Stripe MVP target Mon 8th”": "«Бюджет Q3 одобрен — Stripe MVP в понедельник 8-го»",

  // System messages from server (rendered through localizeSystemTextFragment)
  "Recording started": "Запись начата",
  "Recording stopped": "Запись остановлена",
  "Recording available:": "Запись доступна:",
  "Transcript ready ({{count}} segments):": "Расшифровка готова ({{count}} сегментов):",
  "Video call ended": "Видеозвонок завершён",
  "Video call ended (duration: {{duration}})": "Видеозвонок завершён (длительность: {{duration}})",
  "Download transcript (.{{ext}})": "Скачать расшифровку (.{{ext}})",

  // ── Review pass 5 — final audit ───────────────────────────────────────
  // VoiceMessagePlayer transcription / translation states
  "Transcribing...": "Расшифровка...",
  "No speech detected": "Речь не обнаружена",
  "Transcription failed. Try again.": "Не удалось расшифровать. Попробуйте ещё раз.",
  "Translating to {{lang}}…": "Перевод на {{lang}}…",
  "Translation failed: {{error}}": "Не удалось перевести: {{error}}",

  // StreamView fullscreen toggle
  "Fullscreen (F)": "На весь экран (F)",
  "Exit fullscreen (Esc / F)": "Выйти из полноэкранного (Esc / F)",

  // VoiceEnrollment confirm dialog
  "Delete your voice profile? Translated voice messages will stop being available in your voice.":
    "Удалить ваш голосовой профиль? Переводы голосовых сообщений вашим голосом перестанут работать.",

  // QRLoginView
  "Sign in with QR code": "Вход по QR-коду",
  "Open Scrile Messenger on your phone and scan the QR code to sign in":
    "Откройте Scrile Messenger на телефоне и отсканируйте QR-код для входа",
  "Error": "Ошибка",
  "QR Code": "QR-код",
  "Waiting for scan...": "Ожидание сканирования...",
  "✓ Confirmed! Signing in...": "✓ Подтверждено! Выполняется вход...",
  "QR code expired": "QR-код истёк",
  "Failed to generate QR code": "Не удалось сгенерировать QR-код",
  "Refresh QR code": "Обновить QR-код",

  // Meeting insights system message (generated in ConferenceView, rendered
  // through localizeSystemTextFragment)
  "Meeting insights ready": "ИИ-аналитика встречи готова",
  "{{count}} topics": "{{count}} тем",
  "{{count}} action items": "{{count}} action items",

  // Short labels used inside the ChatFolders SVG infographic on /features.
  // The full versions ("Leave Group", "Hide Chat", "Add to folder") translate
  // to longer Russian strings that overlap the cascading submenu — these are
  // condensed forms used ONLY in that infographic.
  "Leave": "Покинуть",
  "Hide": "Скрыть",
  "To folder": "В папку",

  // Multi-file attachment limit (see config.maxAttachmentCount).
  "You can attach up to {{max}} files": "Можно прикрепить не более {{max}} файлов",

  // Group Topics (Темы)
  "General": "Основной",
  "Topic": "Тема",
  "Manage topics": "Управление темами",
  "New topic name": "Название новой темы",
  'Delete topic "{{name}}"?': "Удалить тему «{{name}}»?",
};
